import { Session } from 'next-auth'
import { UpdateCartRequest, Cart, GeolocationResponse } from '~/types'

import { ICartClient } from '../types/Client'
import { request } from './request'

export class CartClient implements ICartClient {
  addToCart = async (
    payload: UpdateCartRequest[],
    session: Session
  ): Promise<Cart> => {
    const response = await request<Cart>(
      {
        url: `/bff/cart/add`,
        method: 'POST',
        body: payload,
      },
      session
    )

    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }

  public updateCart = async (
    payload: UpdateCartRequest[],
    session: Session
  ): Promise<Cart> => {
    const response = await request<Cart>(
      {
        url: `/bff/cart/update`,
        method: 'PATCH',
        body: payload,
      },
      session
    )
    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }

  public getCart = async (
    session: Session,
    location?: GeolocationResponse
  ): Promise<Cart> => {
    if (!session) {
      return null
    }

    const response = await request<Cart>(
      {
        url: '/bff/cart/details',
        method: 'GET',
        query: {
          longitude: location?.position?.longitude,
          latitude: location?.position?.latitude,
          country: location?.location?.country,
          postcode: location?.location?.postcode,
          address: location?.location?.address,
          suburb: location?.location?.suburb,
          state: location?.location?.state,
        },
      },
      session
    )

    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }

  public freezeCart = async (session: Session): Promise<Cart> => {
    if (!session) {
      return null
    }

    const response = await request<Cart>(
      {
        url: '/bff/cart/freeze',
        method: 'PATCH',
      },
      session
    )

    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }

  public unFreezeCart = async (session: Session): Promise<Cart> => {
    if (!session) {
      return null
    }

    const response = await request<Cart>(
      {
        url: '/bff/cart/unFreeze',
        method: 'PATCH',
      },
      session
    )

    if (response.getErrorSafe()) {
      return null
    }

    return response.getValueSafe()
  }
}
